export const ACTIVITIES_PER_PAGE = 20;
export const ANNOUNCEMENTS_PER_PAGE = 15;
export const CUSTOMERS_PER_PAGE = 40;
export const LEADS_PER_PAGE = 40;
export const PROJECTS_PER_PAGE = 40;
export const EMPLOYEES_PER_PAGE = 40;
export const PARTNERS_PER_PAGE = 40;
export const SPACES_PER_PAGE = 50;
export const DECISION_TYPE_MATRIX_SIZE = 50;
export const DECISIONS_PER_PAGE = 30;
export const INSTALLMENTS_PER_PAGE = 30;
export const DOCUMENTS_PER_PAGE = 20;

export const MILESTONES_LISTS_PER_PAGE = 20;
export const NOTIFICATION_SUBGROUPS_PER_PAGE = 11;
export const SURVEYS_PER_PAGE = 30;
export const TICKETS_PER_PAGE = 30;
export const TODOS_PER_PAGE = 15;
export const TODO_LISTS_PER_PAGE = 10;
export const ASSIGNMENTS_PER_PAGE = 10;
export const EMAIL_EVENTS_PER_PAGE = 100;
export const SESSIONS_PER_PAGE = 100;
export const ISSUES_PER_PAGE = 30;
export const UNITS_PER_PAGE = 30;
export const QUESTIONS_PER_PAGE = 30;
export const QUESTION_LISTS_PER_PAGE = 30;

export const INSPIRATIONS_PER_PAGE = 15;
export const SNIPPETS_PER_PAGE = 15;

export const SURVEY_TYPES_PER_PAGE = 10;

export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 30, 50, 100];
